import { useMemo } from 'react';

import { RAIN_QUILL_AGENT_ID, type IQuillTestRunFocus } from '../agents/quill';
import { createQuillAgentConfig } from '../agents/quill.config';
import { buildRainAdapter } from './buildRainAdapter';
import type { IRainThreadAdapter } from './scope';
import { useAutomationRainAdapterParts } from './useAutomationRainAdapterParts';

/**
 * Automation-scoped Rain thread adapter for the editor chat, on `quill2`.
 *
 * Quill's config is built per-adapter rather than shared because the test-run
 * card closes over the editor's run-view focus.
 */
export function useAutomationRainAdapter(
  automationId: string,
  /** Undefined while the thread is being created — see the parts hook. */
  threadId: string | undefined,
  testRunFocus: IQuillTestRunFocus = {},
): IRainThreadAdapter {
  const { focusedToolCallId, onFocus } = testRunFocus;
  const agentConfig = useMemo(
    () => createQuillAgentConfig({ focusedToolCallId, onFocus }),
    [focusedToolCallId, onFocus],
  );

  const parts = useAutomationRainAdapterParts(
    automationId,
    RAIN_QUILL_AGENT_ID,
    threadId,
  );

  return buildRainAdapter({ ...parts, agentConfig });
}
